<template>
  <v-card flat :loading="loading" :disabled="disabled">
    <v-card-title test-tag="tag-290"><T>Зоны доставки</T></v-card-title>
    <v-card-text>
      <div style="height: calc(100vh - 160px)" class="d-flex flex-column">
        <v-row dense style="flex-shrink: 1">
          <v-col>
            <AddressSuggestionField 
              style="z-index: 1001" 
              :rules="[(v) => v.accuracy < 8 ? $t('Укажите адрес с точностью до номера дома') : true]" 
              :label="$t('Адрес ресторана')" 
              :hint="$t('Укажите адрес ресторана. Его координаты будут отмечены маркером на карте')" 
              :loading="any_loading"
              v-model="restaurant_address" 
              :original_value="config.geocoding.restaurant_address"
              :disabled="disabled"
            />
          </v-col>
        </v-row>
        <v-row dense class="height: 100%" style="flex-grow: 100">
          <v-col cols="4">
            <ListItemsController
              allow_create
              allow_sort
              allow_delete
              allow_edit
              :original_value="config.geocoding.zones"
              :disabled="disabled"
              :label="$t('Зоны доставки')"
              :empty_list_label="$t('Зоны доставки не определены')"
              :default_item="{
                name: '',
                polygon: []
              }"
              v-model="zones"
            >

              <template #list-item="{ item, idx }">

                <v-list-item-avatar>
                  <v-icon :color="idxToColor(idx)">mdi-texture-box</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{item.name}}
                  </v-list-item-title>
                  <!-- <v-list-item-subtitle>Краткая информация об условиях доставки</v-list-item-subtitle> -->
                </v-list-item-content>
              </template>

              <template #dialog="{ item, is_new, submit, remove, showing, idx, close }">
                <v-card :key="is_new ? 'new' : 'edit-'+idx">
                  
                  <v-form v-if="showing" @submit.prevent="submit">
                    <v-card-title test-tag="tag-291" class="d-flex align-center justify-space-between">
                      <div>
                        <T v-if="is_new">Добавление зоны доставки</T>
                        <T v-else>Редактирование зоны доставки</T>
                      </div>

                      <div class="d-flex align-center" style="gap: 8px;">
                        <v-btn test-tag="tag-286" color="primary" icon @click="submit()"><v-icon>mdi-check</v-icon></v-btn>
                        <v-btn test-tag="tag-287" color="red" icon @click="remove()"><v-icon>mdi-delete</v-icon></v-btn>
                        <v-btn test-tag="tag-288" color="error" icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
                      </div>
                    </v-card-title>
                    <v-card-text>

                      <TextField 
                        :label="$t('Название зоны доставки')" 
                        :hint="$t('Не рекомендуется указывать в названии зоны доставки условия доставки')" 
                        :rules="[rules.require]" 
                        v-model="item.name" />

                      <TextField 
                        :label="`${$t('Минимальная сумма для бесплатной доставки')}`"
                        :hint="$t('Минимальная сумма для бесплатной доставки')"
                        :rules="[rules.port, rules.minimalSum($store.getters.config.r_keeper_references.minimal_sum)]"
                        type="number"
                        v-model="item.min_sum_for_delivery"
                      />

                      <TextField 
                        :label="`${$t('Стоимость доставки')}`"
                        :hint="$t('Цена доставки будет прибавляться к сумме заказа')"
                        :rules="[rules.port]"
                        type="number"
                        v-model="item.price_delivery"
                      />
                    
                      <div style="height: 60vh" v-if="is_new || (item || {polygon: []}).polygon.length < 3">
                        <Map ref="map"
                          v-if="dialogMapState(showing) && mapstate" 
                          :center="restaurant_address.coordinates || {lat: 55.7558, lng: 37.6173}" 
                          :zoom="14" 
                          style="position: relative"

                          @draw:created="e => {
                            log(e)
                            
                            if (e.layerType === 'polygon') {
                              item.polygon = e.layer.editing.latlngs[0][0]
                            } 
                          }"
                        >
                          <v-alert v-if="item.polygon.length < 3" colored-border border="left" type="warning" style="position: absolute; left: 55px; top: 10px; right: 10px; z-index: 1001">
                            <T>Добавьте на карту полигон с границами зоны доставки</T>
                          </v-alert>
                          <LMarker v-if="restaurant_address.coordinates" :lat-lng="marker_lat_lng"  />
                          <LPolygon v-for="zone in reversedZonesWithoutCurrent(idx)" :key="zone.idx" :lat-lngs="zone.zone.polygon" :color="idxToColor(zone.prev_idx)" :fillColor="idxToColor(zone.prev_idx)" />
                          <DrawToolbar/>
                        </Map>
                      </div>
                      <v-alert type="info" colored-border border="left" v-else>
                        <T>Для этой зоны доставки уже определены границы, но вы можете</T>
                        <v-btn test-tag="tag-289" @click="item.polygon = []" :disabled="disabled" text color="black"><v-icon>mdi-vector-polygon</v-icon><T>Нарисовать полигон заново</T></v-btn>
                      </v-alert>
                    </v-card-text>
                  </v-form>
                </v-card>
              </template>

            </ListItemsController>

          </v-col>
          <v-col>
            <Map ref="map" @draw:deleted="log" :center="restaurant_address.coordinates || {lat: 55.7558, lng: 37.6173}" :zoom="zoom">
              <LMarker v-if="restaurant_address.coordinates" :lat-lng="marker_lat_lng"  />
              <LPolygon v-for="(zone, idx) in reversed_zones" :key="idx" :lat-lngs="zone.polygon" :color="idxToColor(reversed_zones.length - idx - 1)" :fillColor="idxToColor(reversed_zones.length - idx - 1)" />
            </Map>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import AddressSuggestionField from '../../common/AddressSuggestionField.vue'
import ListItemsController from '../../common/ListItemsController.vue'
import Map from '../../common/Map.vue'
import TextField from '../../common/TextField.vue'
import { LMarker, LPolygon } from 'vue2-leaflet'
import DrawToolbar from './DrawToolbar.vue'

import settings_group_mixin from '../settings_group_mixin'

export default {
  mixins: [settings_group_mixin],
  data: () => ({
    // restaurant_address: {},
    center: {lat: 55.7558, lng: 37.6173},
    zoom: 15,
    mapstate: false
  }),  
  computed: {

    zones: {
      get() {
        return (this.local_config?.geocoding?.zones || [])
      },
      set(v) {
        this.local_config.geocoding.zones = JSON.parse(JSON.stringify(v))
      }
    },
    reversed_zones(){
      let zones = JSON.parse(JSON.stringify(this.zones))
      zones.reverse()
      return zones
    },
    restaurant_address: {
      get(){
        return this.local_config.geocoding ? this.local_config.geocoding.restaurant_address : {}
      },
      set(v){
        this.local_config.geocoding.restaurant_address = JSON.parse(JSON.stringify(v))
        
        this.center = JSON.parse(JSON.stringify(this.restaurant_address.coordinates))
        this.$nextTick(() => {
          this.zoom = 16
        })
      }
    },
    marker_lat_lng(){
      if (this.restaurant_address) {
        return this.restaurant_address.coordinates ? this.restaurant_address.coordinates : {lat: 55.7558, lng: 37.6173}
      } else {
        return {lat: 55.7558, lng: 37.6173}
      }
    }
  },
  components: {
    Map,
    TextField,
    DrawToolbar,
    LPolygon,
    AddressSuggestionField,
    LMarker,
    ListItemsController
  },
  methods: {
    reversedZonesWithoutCurrent(current_idx){
      console.log(current_idx)
      return this.reversed_zones
        .map((zone, idx) => {
          return {
            idx,
            zone,
            prev_idx: this.reversed_zones.length - idx - 1
          }
        })
        .filter((indexed_zone) => {
          return indexed_zone.prev_idx != current_idx
        })
    },
    idxToColor(idx) {
      let colors = this.$store.getters.zone_colors

      return colors[idx % colors.length ]
    },
    dialogMapState(showing){
      if (showing) {
        this.$nextTick(() => {
          this.mapstate = true
        })

      } else {
        this.mapstate = false
      }

      return true
    },
    log(a,b,c,d) {
      console.log('mylog', a,b,c,d)
    },
    validate(){
      if ((this.restaurant_address.accuracy || 8) < 8) {
        throw new Error(this.$t('Укажите адрес ресторана с точностью до номера дома'))
      }
    }
  },
  mounted(){
    // this.$nextTick(() => {
    //   const map = this.$refs.map.mapObject;
    //   const drawControl = new window.L.Control.Draw({
    //     position: 'topright',
    //     draw: {
    //       polyline: {
    //         allowIntersection: false,
    //         showArea: true
    //       },
    //       polygon: true,   // disable or enable with true/false
    //       rectangle: false,
    //       circle: false,
    //       marker: false
    //     }
    //   });
    //   map.addControl(drawControl);
    // })
  }
}
</script>

<style>
ul, ol {
  padding: 0 !important;
}
</style>